import { CommentType } from "~/common/constants";
import { fetchWithAuth } from "~/common/fetch";
import {
  API_GET_PATIENT_COMMENTS,
  API_POST_PATIENT_COMMENTS,
  API_POST_PATIENT_QUESTIONS,
} from "~/config";
import type { TUserActionNotification } from "~/reducers/dashboard";
import type { AppDispatch } from "~/store";
import type { TPatient } from "~/types/patient";

import { addUserActionNotification } from "./user_notification";

export function getComments(patient_id: TPatient["patient_id"]) {
  return (dispatch: AppDispatch) => {
    return fetchWithAuth(API_GET_PATIENT_COMMENTS(patient_id))
      .then((response) => {
        if (!response.ok) {
          throw Error("Error occurred trying to fetch comments");
        }
        return response;
      })
      .then((response) => response.json())
      .then((json) => {
        dispatch({ type: "GET_PATIENT_COMMENTS", json });
        return true;
      })
      .catch(() => {
        dispatch({ type: "GET_PATIENT_COMMENTS", json: [] });
        return false;
      });
  };
}

export function sendComment(
  patient_id: TPatient["patient_id"],
  comment: string,
  type: CommentType = CommentType.COMMON,
  plan_id: string | null = null,
) {
  const NOTIFICATION_MSG_OK: TUserActionNotification = {
    message: "notify.comment",
    level: "success",
    position: "tl",
    autoDismiss: 4,
  };

  const NOTIFICATION_MSG_ERROR: TUserActionNotification = {
    message: "notify.comment.error",
    level: "error",
    position: "tl",
    autoDismiss: 4,
  };

  return async (dispatch: AppDispatch) => {
    try {
      const response = await fetchWithAuth(API_POST_PATIENT_COMMENTS(patient_id), {
        method: "POST",
        body: JSON.stringify({ comment, type, plan_id }),
      });
      if (!response.ok) {
        throw new Error("Error occurred while trying to save comment");
      }
      const json = await response.json();
      dispatch({ type: "POST_PATIENT_COMMENTS", json });
      dispatch(addUserActionNotification(NOTIFICATION_MSG_OK));
    } catch {
      dispatch(addUserActionNotification(NOTIFICATION_MSG_ERROR));
    }
  };
}

export function sendQuestion(patient_id: TPatient["patient_id"], comment: string) {
  const NOTIFICATION_MSG_OK: TUserActionNotification = {
    message: "notify.question",
    level: "success",
    position: "tl",
    autoDismiss: 4,
  };

  const NOTIFICATION_MSG_ERROR: TUserActionNotification = {
    message: "notify.question.error",
    level: "error",
    position: "tl",
    autoDismiss: 4,
  };

  return (dispatch: AppDispatch) => {
    fetchWithAuth(API_POST_PATIENT_QUESTIONS(patient_id), {
      method: "POST",
      body: JSON.stringify({ comment }),
    })
      .then((response) => {
        if (!response.ok) {
          throw new Error("Error occurred trying to send question");
        }
        return response;
      })
      .then((response) => response.json())
      .then((json) => {
        dispatch({ type: "POST_PATIENT_COMMENTS", json });
        dispatch(addUserActionNotification(NOTIFICATION_MSG_OK));
      })
      .catch(() => {
        dispatch(addUserActionNotification(NOTIFICATION_MSG_ERROR));
      });
  };
}
